import produce from 'immer';
import actionTypes from 'store/actionTypes';
import { initialAIStateData } from 'store/initialStateData';
import { AIChatState } from 'models/index.m';

export const aiChatReducer = (
  state = initialAIStateData,
  action: any,
): AIChatState => {
  if (!action) {
    return state;
  }

  return produce(state, (draft) => {
    switch (action.type) {
      case actionTypes.SET_AI_CHAT_STATE:
        draft.isAIChatOpen = action.payload;
        break;
      case actionTypes.SET_AI_CHAT_CONTEXT_ID:
        draft.aiChatContextId = action.payload;
        break;
      case actionTypes.SET_AI_CHAT_HISTORY:
        draft.aiChatHistory = action.payload;
        break;
      case actionTypes.SET_AI_CHAT_LOADING:
        draft.aiChatLoading = action.payload;
        break;
      case actionTypes.SET_AI_CHAT_ERROR:
        draft.aiChatError = action.payload;
        break;
      default:
        break;
    }
  });
};
